/**
 * Formatting and color threshold helpers for Ops Scorecards (OPS_SCORECARD_PLAN §1 & §4).
 */

export function fmtDuration(minutes: number | null | undefined): string {
  if (minutes == null) return '—';
  if (minutes < 60) return `${Math.round(minutes)}m`;
  if (minutes < 1440) {
    const hours = minutes / 60;
    return `${hours % 1 === 0 ? hours.toFixed(0) : hours.toFixed(1)}h`;
  }
  const days = minutes / 1440;
  return `${days % 1 === 0 ? days.toFixed(0) : days.toFixed(1)}d`;
}

export function fmtRate(rate: number | null | undefined): string {
  if (rate == null) return '—';
  return `${Math.round(rate * 100)}%`;
}

export function fmtCount(count: number | null | undefined): string {
  if (count == null) return '—';
  return String(count);
}

/**
 * Target colors from plan §4:
 * green <= target, amber <= 2x target, red beyond.
 */
export function durationAccent(
  actualMinutes: number | null | undefined,
  targetMinutes: number,
): 'default' | 'green' | 'amber' | 'red' {
  if (actualMinutes == null) return 'default';
  if (actualMinutes <= targetMinutes) return 'green';
  if (actualMinutes <= 2 * targetMinutes) return 'amber';
  return 'red';
}

/**
 * Higher is better for rates.
 */
export function rateAccent(rate: number | null | undefined): 'default' | 'green' | 'amber' | 'red' {
  if (rate == null) return 'default';
  if (rate >= 0.9) return 'green';
  if (rate >= 0.75) return 'amber';
  return 'red';
}

/**
 * Advance an ISO date string (YYYY-MM-DD) by one UTC day.
 */
export function addOneDay(isoDateStr: string): string {
  const d = new Date(`${isoDateStr}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + 1);
  return d.toISOString().slice(0, 10);
}

